import React from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";

import Chart from "Components/Common/Chart";
import { lineChartColors } from "common/constant";

const ComplianceRateOverTimeLineChart = ({ lineChartData, t }) => {
  const daysInMonth = Array.from({ length: 31 }, (_, i) => i + 1);
  const initialOption = {
    chart: {
      type: "line",
      toolbar: {
        show: true,
        tools: {
          zoom: false,
          zoomin: false,
          zoomout: false,
          pan: false,
          reset: false,
        },
      },
    },
    colors: lineChartColors,
    xaxis: {
      categories: daysInMonth,
      tickAmount: 31,
      step: 1,
    },
    yaxis: {
      min: 0,
      max: 3,
      tickAmount: 3,
      labels: {
        formatter: function (val) {
          return val === 1 ? "First Half" : val === 2 ? "Second Half" : "";
        },
      },
    },
    fill: {
      opacity: 1,
    },
    tooltip: {
      enabled: false,
    },
  };

  const series = [
    {
      name: "First Half",
      data:
        lineChartData[0]?.count > 0
          ? Array(lineChartData[0]?.count).fill(1)
          : [""],
    },
    {
      name: "Second Half",
      data:
        lineChartData[1]?.count > 0
          ? Array(lineChartData[1]?.count).fill(2)
          : [""],
    },
  ];

  return (
    <Chart
      title={t("Compliance Rate Over Time")}
      options={initialOption}
      series={series}
      height={350}
      type="line"
    />
  );
};

ComplianceRateOverTimeLineChart.propTypes = {
  lineChartData: PropTypes.arrayOf(PropTypes.object).isRequired,
  t: PropTypes.func,
};

export default withTranslation()(ComplianceRateOverTimeLineChart);
